import { he } from 'date-fns/locale'
import React, { useMemo, useState, useCallback } from 'react'
import ReactDatePicker from 'react-datepicker'
import styled from 'styled-components'
import CalendatDay from '../../../../../../generic/icons/IconLib/CalendarIcon'
import { convertToDate } from '../../../../../../modules/convertDateString'
import { format, parse, isValid } from 'date-fns'

type Props = {
  selected: Date,
  onChange: (date: Date) => void
  disabled?: boolean
  readOnly?: boolean
}

const DatePickerISO = ({
  selected,
  onChange,
  disabled,
  readOnly

}: Props) => {
  const convertedDate = useMemo(() => {
    return convertToDate(format(selected, 'yyyyMMdd'))
  }, [selected])
  
  return (
    <Overlay>
      <ReactDatePicker
        className='date-picker-iso'
        selected={selected}
        onChange={(date) => { if (date) onChange(date) }}
        shouldCloseOnSelect
        locale={he}
        disabled={disabled}
        dateFormat={'dd/MM/yyyy'}
        popperProps={{ strategy: 'fixed' }}
        popperPlacement="bottom-end"
        customInput={
        <MainWrapper>
          <Input 
            value={convertedDate}
            readOnly={readOnly}
        
          />
            <IconWrapper>
              <CalendatDay />
            </IconWrapper>
        </MainWrapper>
        }
      />

    </Overlay>
    
  )
}
const Overlay = styled.div`
z-index: 3;
  span {
    display: none;
  }
`
const MainWrapper = styled.label`
  
    position: relative;
    background: #fff;
    width: 135px;
    display: flex;
    justify-content: flex-end;
    border-radius: 30px;
    padding: 1em ;
    color: #297F76;
    z-index: 2;
    box-shadow: 0px 1px 2px 2px rgba(41,127,118, 0.1);
    span {
      display: none;
    }
    
  .date-picker-iso {
    border: none;
    direction: rtl;
    width: 100px;
    font-size: 1.1em;
    outline: none;
    color: #297F76;
    cursor: pointer;
    /* z-index: 55; */
  }
`
const IconWrapper = styled.div`
  position: absolute;
  top: calc(50% - 1.1em);
  left: 0;
  width: 2em;
  height: 2em;
  display: flex;
  justify-content: center;
  align-items: center;
  /* background: #80E081; */
  z-index: 1;
  border-radius: 50%;
  cursor: pointer;
  transition: 0.3s;
  &:hover {
    opacity: 0.8;
  }
`
const Input = styled.input`
    border: none;
    direction: rtl;
    max-width: 80px;
    font-size: 1em;
    outline: none;
    color: #297F76;
    cursor: pointer;
    z-index: 55;
    /* padding: 0 0.5em; */
`
export default DatePickerISO